import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  const rows = document.getElementsByClassName('clickable-row')

  Array.from(rows).forEach((row) => {
    row.addEventListener('click', () => {
      window.location = row.attributes.href.value
    })
  })
})
